import { usePersonReadDataContext } from '@aibees/elephant/context';
import { usePersonalityAnalysisStatus } from '@aibees/elephant/hooks/people/use-personality-analysis-status';
import { Grid2 } from '@aibees/shared/components';
import { classnames } from '@aibees/shared/utils';
import { Box, Button, Typography } from '@mui/material';
import { memo } from 'react';
import { PeopleAnalysisUnlockCardContentInfoItem } from '../people-analysis-unlock-card-content-info-item';
import * as Styled from './styles';
import * as SX from './sx';
import type { PeopleAnalysisUnlockCardContentProps as Props } from './types';

export const PeopleAnalysisUnlockCardContent = memo(({ className }: Props) => {
  const { api } = usePersonReadDataContext();
  const { failed } = usePersonalityAnalysisStatus(undefined, api?.data);

  return (
    <Styled.Wrapper
      className={classnames('PeopleAnalysisUnlockCardContent', className)}
      sx={SX.root}
      container
      columns={12}
      // columnSpacing={4}
      // rowSpacing={4}
    >
      {failed ? (
        <Grid2 xs={12} md={12} display="flex" flexDirection="column" rowGap={1}>
          <Typography variant="body4" fontWeight={700} color="black">
            Hmm, it looks like something went wrong. Lets try again
          </Typography>

          <Typography variant="body4" fontWeight={400} color="black">
            No Credits were deducted
          </Typography>

          <Typography sx={SX.footer}>
            if the issue continues please <span>Contact Support</span>
          </Typography>
        </Grid2>
      ) : (
        <>
          <Grid2
            xs={12}
            md={4.5}
            display="flex"
            flexDirection="column"
            rowGap={1}
          >
            <PeopleAnalysisUnlockCardContentInfoItem text="Deep Insights" />
            <PeopleAnalysisUnlockCardContentInfoItem text="Real-Time Data" />
            <PeopleAnalysisUnlockCardContentInfoItem text="Unlock Potential" />
          </Grid2>
          <Grid2
            xs={12}
            md={7.5}
            display="flex"
            flexDirection="column"
            justifyContent="space-between"
          >
            <Box sx={SX.rightRow}>
              <Typography variant="body5" fontWeight={400} color="grey.500">
                Data Sourced & Analyzed Real-Time
              </Typography>
            </Box>
            <Box sx={SX.rightRow}>
              <Button variant="outlined" size="xsmall" disabled>
                View Sample
              </Button>
            </Box>
          </Grid2>
        </>
      )}
    </Styled.Wrapper>
  );
});

PeopleAnalysisUnlockCardContent.displayName = 'PeopleAnalysisUnlockCardContent';
